qw-calendar .flatpickr-calendar:before, qw-calendar .flatpickr-calendar:after {
  display: none !important;
}

qw-calendar {
  display: none;
}